import { useEffect, useState } from 'react'
import { useAppSelector } from '../../../state/hooks'
import { isRestaurantOpen as isMenuOpen } from '../../../helpers/restaurantHours'

export const useCheckItemAvailability = (itemId: string) => {
	const { loadedData } = useAppSelector(state => state.data)
	const { allowOrdersOutsideOrgHours, localTimezone } = useAppSelector(state => state.settings)
	const [isItemAvailable, setIsItemAvailable] = useState(false)
	const [isMenuItemLoaded, setIsMenuItemLoaded] = useState(false)

	useEffect(() => {
		if (!!itemId) {
			const isItemInMenu = isMenuOpen(
				loadedData[itemId],
				loadedData[global.org].hours,
				allowOrdersOutsideOrgHours,
				localTimezone
			)

			setIsItemAvailable(isItemInMenu)

			// // // Delaying the loading of the item to avoid the last item id from persisting when rendering a new item page.
			const timer = setTimeout(() => {
				setIsMenuItemLoaded(true)
			}, 500)

			return () => {
				clearTimeout(timer)
			}
		}
	}, [itemId, loadedData, allowOrdersOutsideOrgHours, localTimezone])

	return { isItemAvailable, isMenuItemLoaded }
}
